module.exports = __webpack_public_path__ + "img/privacy-policy.dd0b0825.jpg";